<template>
  <div class="layout-events">
    <div class="layout-header" :class="$globalConfig.headerOpen ? '':'header-close'">
      <app-header>
        <app-menu ref="appMenu" slot="app-menu"></app-menu>
      </app-header>
    </div>
    <div class="layout-body">
      <app-sidebar class="layout-side"
                   :class="$globalConfig.headerOpen ? '':'header-close'"
                   :menu="sideBarMenu"
                   :select="sideBarMenuCurrentItem"
                   @select="handleSelectSideBarMenuItem">
      </app-sidebar>
      <div class="layout-main" :class="$globalConfig.headerOpen ? '' + (sideBarOpen ? '':'side-bar-close'):'header-close' + (sideBarOpen ? '':' side-bar-close')">
        <app-breadcrumb class="layout-breadcrumb" :class="$globalConfig.headerOpen ? '' + (sideBarOpen ? '':'side-bar-close'):'header-close' + (sideBarOpen ? '':' side-bar-close')" :breadcrumb="breadcrumb"></app-breadcrumb>
        <div class="layout-content"  :class="$globalConfig.headerOpen ? ($globalConfig.fullScreen ? 'full-screen':''):'header-close' + ($globalConfig.fullScreen ? ' full-screen':'')">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import LayoutEvents from './LayoutEvents.js'
export default LayoutEvents
</script>

<style lang="scss">
@import "LayoutEvents";
</style>



// WEBPACK FOOTER //
// src/layouts/layoutEvents/LayoutEvents.vue